module.exports = __webpack_public_path__ + "img/first-1.bd34d332.webp";